<template>
	<div class="main-sidebar-right">

		<!-- progress-badges-start -->
		<div class="progress-badges">
			<h2>YOUR PROGRESS BADGES</h2>
			<div class="single-progress-badge">
				<div class="single-badge-content">
					<h3>Commabassador</h3>
					<span>Comment on stories!</span>
				</div>
				<div class="progress-bar">
					<div class="inner-progress-bar" style="width: 80%"></div>
				</div>
			</div><!--  /. single-progress-badge -->

			<div class="single-progress-badge">
				<div class="single-badge-content">
					<h3>Elite Comma</h3>
					<span>Keep reading!</span>
				</div>
				<div class="progress-bar">
					<div class="inner-progress-bar" style="width: 30%"></div>
				</div>
			</div><!--  /. single-progress-badge -->
		</div>
		<!-- progress-badges-end -->

		<div class="badges-border-bottom"></div>

		<!-- story-challange-start -->
		<div class="story-challange">
			<h2>STORY CHALLENGE</h2>
			<p>Today's story challenge is Hydrant. Make a story and tag: hydrant for a chance to be showcased in this section tomorrow</p>
			<a href="#">JOIN A CHALLENGE</a>
		</div>
		<!-- story-challange-end -->
		
		<div class="badges-border-bottom"></div>

		<!-- humor-topcs-start -->
		<div class="humor-topcs">
			<h2>HUMOR TOPICS</h2>

			<div class="humor-topcs-single" v-for="(data, key) in humorTopics" :key="key">
				<div class="humor-topcs-sl">
					{{ key+1 }}
				</div>
				<div class="humor-topcs-details">
					<router-link to="/" class="navitem">
                        {{ data.title }}
                     </router-link>
					<div class="humor-topcs-btm">
						<p>{{ data.author }}</p>
						<span class="circle"></span>
						<span>{{ data.time }}</span>
					</div>
				</div>
			</div><!-- /. humor-topcs-single -->
	

		</div>
		<!-- humor-topcs-end -->
		
		<div class="badges-border-bottom"></div>

		<!-- suggested-creators-start -->
		<div class="suggest-creator">
			<h2>SUGGESTED CREATORS</h2>

			<div class="suggest-creator-single" v-for="(data,key) in creators" :key="key">
				<div class="creator-single-wrap">
					<img :src="require(`@/assets/images/${data.img}`)" :alt="data.name" />
					<div class="suggest-creator-desc">
						<h2>{{ data.name }}</h2>
						<p>{{ data.userName }}</p>
					</div>
				</div>
				<div class="creator-single-btn">
					<button @click="followerAddeed(key)" class="check" type="button" v-if="data.isAdded==true">
						<img src="../../assets/icon/check-icon.svg" alt="icon" />
					</button>
					<button @click="followerAddeed(key)" class="plus" type="button" v-else>
						<img src="../../assets/icon/plus-icon.svg" alt="icon" />
					</button>
				</div>
			</div>
			<!-- /. suggest-creator-single -->


		</div>
		<!-- suggested-creators-end -->

	</div>
</template>



<script>


export default {
  name: "main-sidebar-right",

	data(){
		return{
			humorTopics:[
				{
					title: 'The Hidden Story of Charlie Chaplin',
					author: 'Jagat Shahidullah',
					time: 'a day ago'
				},
				{
					title: 'The Hidden Story of Charlie Chaplin',
					author: 'Jagat Shahidullah',
					time: 'a day ago'
				},
				{
					title: 'The Hidden Story of Charlie Chaplin',
					author: 'Jagat Shahidullah',
					time: 'a day ago'
				},
				{
					title: 'The Hidden Story of Charlie Chaplin',
					author: 'Jagat Shahidullah',
					time: 'a day ago'
				},
			],
			creators:[
				{
					id:1,
					name: 'Neville Griffin',
					userName: '@nevilleg',
					isAdded: true,
					img:'f1.png'
				},
				{
					id:2,
					name: 'Jon Doe',
					userName: '@jon',
					isAdded: false,
					img:'f2.png'
				},
				{
					id:3,
					name: 'Shuvo sd',
					userName: '@shuvo',
					isAdded: true,
					img:'f3.png'
				},
				{
					id:4,
					name: 'Alok Paul',
					userName: '@alok',
					isAdded: false,
					img:'f4.png'
				},
				{
					id:5,
					name: 'Neville Griffin',
					userName: '@nevilleg',
					isAdded: true,
					img:'f1.png'
				},
				{
					id:6,
					name: 'Neville Griffin',
					userName: '@nevilleg',
					isAdded: false,
					img:'f1.png'
				}
			],
		}
	},

	methods:{

		followerAddeed(id) {
			this.creators[id].isAdded = !this.creators[id].isAdded;
		}
	}

}

</script>



<style type="text/css">


	.main-sidebar-right{
		width: 23%;
	    padding: 20px 30px;
	    border-right: 1px solid #ddd;
	    height: calc(100vh - 176px);
	    position: -webkit-sticky;
	    position: sticky;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    right: 0%;
	    top: 175px;
	    background: #f1f2f4;
	    -webkit-box-shadow: -5px 0px 40px rgba(33,65,99,0.05);
	    box-shadow: -5px 0px 40px rgba(33,65,99,0.05);
	    background: #fff;
	    overflow: auto;
	}

	.main-sidebar-right::-webkit-scrollbar{
		display: none;
	}

	.badges-border-bottom {
		margin: 35px 0px;
		height: 1px;
		background: #e7eaed;
	}


	/** progress badges css **/
	.progress-badges>h2 {
	    margin: 11px 0px 30px;
	    color: #214163;
	    font-family: Lato;
	    font-size: 16px;
	    font-weight: 700;
	    line-height: 19px;
	    letter-spacing: 1px;
	}
	.single-progress-badge{
		margin-bottom: 30px;
	}
	.single-badge-content {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	        -ms-flex-pack: justify;
	            justify-content: space-between;
	    -webkit-box-align: center;
	        -ms-flex-align: center;
	            align-items: center;
	    margin-bottom: 15px;
	}
	.single-badge-content>h3 {
	    font-size: 14px;
	    line-height: 17px;
	    letter-spacing: 0.875px;
	}

	.single-badge-content > span {
		font-size: 11px;
	    opacity: 0.4;
	}
	.progress-bar {
	    -webkit-box-sizing: border-box;
	            box-sizing: border-box;
	    position: relative;
	    height: 12px;
	    background: #E7EAED;
	    width: 100%;
	    border-radius: 30px;
	    overflow: hidden;
	}

	.inner-progress-bar {
	    border-radius: 30px;
		background: #826af9;
		height: 100%;
	}

	/** story challange css **/
	.story-challange {
	    background: #d8d8d8;
	    padding: 35px 25px;
	}
	.story-challange>h2 {
	    font-size: 16px;
	    line-height: 19px;
	    letter-spacing: 1.142857px;
	}
	.story-challange>p {
	    font-size: 12px;
	    line-height: 24px;
	    letter-spacing: 0.4285714px;
	    opacity: 0.7;
	    color: #000;
	}
	.story-challange > a {
	    color: #62b4b4;
	    font-size: 14px;
	    font-weight: 700;
	    letter-spacing: 1px;
	    position: relative;
	}

	.story-challange > a:before {
	    content: "";
	    position: absolute;
	    width: 100%;
	    height: 1px;
	    bottom: -10px;
	    left: 0;
	    background-color: #00c6c6;
	    visibility: hidden;
	    -webkit-transform: scaleX(0);
	    -ms-transform: scaleX(0);
	        transform: scaleX(0);
	    -webkit-transition: all .2s cubic-bezier(1,.25,0,.75) 0s;
	    -o-transition: all .2s cubic-bezier(1,.25,0,.75) 0s;
	    transition: all .2s cubic-bezier(1,.25,0,.75) 0s;
	}

	.story-challange > a:hover:before {
	    visibility: visible;
	    -webkit-transform: scaleX(1);
	    -ms-transform: scaleX(1);
	        transform: scaleX(1);
	}

	/** humor topcs css **/
	.suggest-creator > h2,
	.humor-topcs > h2 {
	    font-size: 16px;
	    letter-spacing: 1px;
	    margin-bottom: 20px;
	}

	.humor-topcs-sl {
	    width: 50px;
	    height: 50px;
	    background: #edfafd;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	        -ms-flex-pack: center;
	            justify-content: center;
	    -webkit-box-align: center;
	        -ms-flex-align: center;
	            align-items: center;
	    border-radius: 100%;
	    color: #5cd5e9;
	    font-size: 18px;
	    font-weight: 700;
	    letter-spacing: 0.6428571px;
	    margin-right: 10px;
	}

	.humor-topcs-single {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: start;
	        -ms-flex-align: start;
	            align-items: flex-start;
	    margin-bottom: 20px;
	}

	.humor-topcs-details>a {
	    font-size: 14px;
	    font-weight: 700;
	    letter-spacing: 0.5px;
	    margin-top: 3px;
	      color: #214163;
	}

	.humor-topcs-btm>p {
		margin: 0px;
	    font-size: 12px;
	    line-height: 14px;
	    letter-spacing: 0.5px;
	}

	.humor-topcs-btm {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	        -ms-flex-pack: justify;
	            justify-content: space-between;
	    margin-top: 10px;
	        -webkit-box-align: center;
	            -ms-flex-align: center;
	                align-items: center;
	}

	.humor-topcs-btm>span {
	    font-size: 12px;
	    letter-spacing: 0.09px;
	    opacity: 0.5;
	}
	.humor-topcs-btm>span.circle{
	    width: 5px;
	    height: 5px;
	    background: #214163;
	    opacity: 0.5;
	    border-radius: 100%;
	}

	/** creator-single css **/
	.suggest-creator-single {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    margin-bottom: 15px;
	}

	.creator-single-wrap {
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: start;
	        -ms-flex-pack: start;
	            justify-content: flex-start;
	    -webkit-box-align: center;
	        -ms-flex-align: center;
	            align-items: center;
	}

	.creator-single-wrap>img {
	    width: 50px;
	    height: 50px;
	    border-radius: 100%;
	}

	.suggest-creator-desc {
	    margin-left: 12px;
	}
	.suggest-creator-desc>h2 {
	    font-size: 14px;
	    line-height: 20px;
	    letter-spacing: 0.5px;
	}
	.suggest-creator-desc>p {
	    font-size: 12px;
	    letter-spacing: 0.5px;
	    margin: 0px;
	}
	.creator-single-btn button {
	    background: none;
	    border: none;
	    width: 40px;
	    height: 40px;
	    border-radius: 5px;
	    border: solid 1px #214163;
	    line-height: 40px;
	    cursor: pointer;
	    outline: none;
	    -webkit-transition: .5s;
	    -o-transition: .5s;
	    transition: .5s;
	}
	.creator-single-btn button.check {
	    border-color: #00c6c6;
	    background: #00c6c6;
	    line-height: 0px;
	    -webkit-transition: .5s;
	    -o-transition: .5s;
	    transition: .5s;
	}

	.creator-single-btn button img {
	    width: 15px;
	    max-height: 15px;
	}

	.creator-single-btn button.check img {
	    width: 40px;
	    max-height: 40px;
	}

	.creator-single-btn button:hover{
		-webkit-box-shadow: 0px 0px 26px rgba(145, 145, 145, 0.72);
		        box-shadow: 0px 0px 26px rgba(145, 145, 145, 0.72);
	    -webkit-transition: .5s;
	    -o-transition: .5s;
	    transition: .5s;
	}
	.creator-single-btn button.check:hover{
		-webkit-box-shadow: 0px 0px 26px rgb(0, 198, 198);
		        box-shadow: 0px 0px 26px rgb(0, 198, 198);
	    -webkit-transition: .5s;
	    -o-transition: .5s;
	    transition: .5s;
	}



  /** reaction css **/
  @media only screen and (min-width: 1200px) and (max-width: 1400px) {

    .main-sidebar-right {
        padding: 20px 20px;
    }

  }

  @media only screen and (max-width: 1199px) {

    .main-sidebar-right {
	    width: 30%; 
	    height: 160vh;
	    overflow: auto;
	    position: -webkit-sticky;
	    position: sticky;
	    top:210px;
	    margin-bottom: 60px;
	    border-radius: 10px;
    }

  }

  @media only screen and (max-width: 1092px) {

    .main-sidebar-right {
        width: 35%;
        height: 160vh;
        top: 140px;
    }
   }




  	@media only screen and (max-width: 768px) {
		.suggest-creator, .humor-topcs, .story-challange {
		    display: none;
		}

		.main-sidebar-right {
		    height: auto;
		    top: auto;
		    margin-bottom: 30px;
		    -webkit-box-shadow: none !important;
		            box-shadow: none !important;
		}

		.main-sidebar-right .badges-border-bottom{
			display: none;
		}
	}
</style>